import { useTranslation } from 'react-i18next'

import { useBankAccount } from '@/Contract/ui/context'
import { contractTranslation } from '@/Contract/ui/contractTranslation'
import { LogaltyIframe } from '@/Logalty/ui/organisms'
import { ProtectedWrapper } from '@/Shared/ui/navigation'

export const ChangeBankAccountStep3 = (): JSX.Element => {
  const { t } = useTranslation()
  const {
    logalty: { logalty },
    nextStep,
  } = useBankAccount()

  return (
    <ProtectedWrapper
      title={t(contractTranslation.changeBankAccount.modal.title)}
      description={t(contractTranslation.changeBankAccount.modal.description)}
    >
      <LogaltyIframe logalty={logalty} callback={nextStep} />
    </ProtectedWrapper>
  )
}
